import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './providers';
import { router } from './router';

export function App(): JSX.Element {
  useEffect(() => {
    const splash = document.getElementById('splash-gate');
    if (splash) splash.remove();
  }, []);

  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
